import action from '../../../abstract/action.js';
import crmMailsApi from '../../../../../api-v2/crm/mailing/crm-mails.js'
import notifySuccess from '../../../../procedures/notify-success.js';
import notifyError from '../../../../procedures/notify-error.js';

export default action({
  label: 'Oznacz jako przeczytane',
  icon: 'EditIcon',
  main: ({ item }) => item.status && item.status === 'SENT',
  render: ({ item }) => item.status && item.status === 'SENT',
  handle: async ({ reloadList, $vs, item }) => {
    $vs.loading();
    try {
      await crmMailsApi.markAsRead(item.original);

      notifySuccess({
        $vs,
        text: 'Oznaczono jako przeczytane',
      });
      reloadList();
    } catch (error) {
      notifyError({
        $vs,
        text: 'Nie udało się oznaczyć jako przeczytane',
      });
    } finally {
      $vs.loading.close();
    }
  },
});
